// extracted by mini-css-extract-plugin
module.exports = {"link":"StatusBadgeJobTitle_link__k05vl"};